import {
  CreateCompetitionsReportDto,
  GetCompetitionsReportDto,
  GetCompetitionsReportGoalsDto,
  GoalFilterDto,
  IFivGoal,
  IFivReport,
  IRingGoalResult,
  IUploadCompetitionsReport,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class CompetitionsApi {
  static uploadCompetitionsReport(
    goalGroupId: string,
    formData: FormData,
  ): Promise<AxiosResponse<IFivReport[]>> {
    return AdmiralApi.apiCall<IFivReport[]>({
      method: 'POST',
      url: `${BASE_URL}/competitions/upload/${goalGroupId}`,
      data: formData,
    });
  }

  static validateUploadedCompetitionsReport(
    uploadCompetitionsReport: IUploadCompetitionsReport,
  ): Promise<AxiosResponse<IUploadCompetitionsReport>> {
    return AdmiralApi.apiCall<IUploadCompetitionsReport>({
      method: 'POST',
      url: `${BASE_URL}/competitions/validate`,
      data: uploadCompetitionsReport,
    });
  }

  static createCompetitionsReport(dto: CreateCompetitionsReportDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<IFivReport>({
      method: 'POST',
      url: `${BASE_URL}/competitions/report/create`,
      data: dto,
    });
  }

  static getLatestCompetitionsReport(
    getCompetitionsReportDto: GetCompetitionsReportDto,
  ): Promise<AxiosResponse<IFivReport[]>> {
    return AdmiralApi.apiCall<IFivReport[]>({
      method: 'POST',
      url: `${BASE_URL}/competitions/latest-reports`,
      data: getCompetitionsReportDto,
    });
  }

  static getCompetitionsReport(
    getCompetitionsReportDto: GetCompetitionsReportDto,
  ): Promise<AxiosResponse<IFivReport[]>> {
    return AdmiralApi.apiCall<IFivReport[]>({
      method: 'POST',
      url: `${BASE_URL}/competitions/latest-reports`,
      data: getCompetitionsReportDto,
    });
  }

  static getLatestCompetitionsReportGoals(
    getCompetitionsReportGoalsDto: GetCompetitionsReportGoalsDto,
  ): Promise<AxiosResponse<IFivGoal[]>> {
    return AdmiralApi.apiCall<IFivGoal[]>({
      method: 'POST',
      url: `${BASE_URL}/competitions/report/goals`,
      data: getCompetitionsReportGoalsDto,
    });
  }

  static getLatestRingCompetitionsReportGoals(
    getCompetitionsReportGoalsDto: GetCompetitionsReportGoalsDto,
  ): Promise<AxiosResponse<IFivGoal[]>> {
    return AdmiralApi.apiCall<IFivGoal[]>({
      method: 'POST',
      url: `${BASE_URL}/competitions/report/goals`,
      data: getCompetitionsReportGoalsDto,
    });
  }

  static getRingGoalResult(dto?: GoalFilterDto): Promise<AxiosResponse<IRingGoalResult>> {
    return AdmiralApi.apiCall<IRingGoalResult>({
      method: 'POST',
      url: `${BASE_URL}/competitions/ring/result`,
      data: dto,
    });
  }
}
